module.exports = __webpack_public_path__ + "src/assets/img/footerlogo.4aeeee53.png";